import safeFetch from 'lib/requests/fetch';

export interface ISearchActiveLearnersCsvPayload {
  userIds: number[];
  exclude: boolean;
  userSearchTerm?: string;
}

export const getActiveLearnersCsv = async (
  data: ISearchActiveLearnersCsvPayload
) =>
  safeFetch<Blob>('/admin/dashboard/search-active-learners-csv', {
    method: 'POST',
    body: JSON.stringify(data),
  });
